<template>
  <div class="sh-page">
    <div class="sh-page__glow sh-page__glow--one" aria-hidden="true"></div>

    <div class="sh-card">
      <div class="sh-card__head">
        <LogoTile v-if="branding" :branding="branding" :alt="tenantName" :size="44" />
        <span class="unavailable__badge"><v-icon size="20" color="warning">cloud_off</v-icon></span>
        <h1 class="sh-card__title">{{ tenantName }}</h1>
        <p class="sh-card__subtitle">{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useSessionStore } from "@/stores/session";
import LogoTile from "@/shell/LogoTile.vue";

export default defineComponent({
  name: "Unavailable",
  components: { LogoTile },
  setup() {
    const session = useSessionStore();
    const found = computed(() => !!session.tenant?.found);
    const tenantName = computed(() => (found.value ? session.tenant?.name || "This app" : "Metaship"));
    const branding = computed(() => session.tenant?.branding ?? null);
    const message = computed(() => {
      if (!found.value) return "This app is not available at this address.";
      switch (session.tenant?.status) {
        case "DISABLED":
          return "This app has been temporarily disabled.";
        case "PROVISIONING":
          return "This app is still being set up — check back shortly.";
        case "FAILED":
        case "DRAFT":
        case "DEPROVISIONING":
        case "DELETED":
        default:
          return "This app is not available right now.";
      }
    });
    return { tenantName, branding, message };
  },
});
</script>

<style scoped>
.unavailable__badge {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(var(--v-theme-warning), 0.14);
}
</style>
